import React from "react";
import "./src/index.css";
import WidgetData from "./src/data/chart.json";
import { Widget } from "@learningblocks/widgets";

export default function PCR2(props) {
  return (
    <Widget
      widget={"PCR2"}
      inline="true"
      visible={"true"}
      widgetData={WidgetData}
      toPrevious={props.toPrevious}
      toNext={props.toNext}
      //usersnap="//api.usersnap.com/load/ceaa5c16-2d5f-45fd-9a81-2db3617035b5.js"
    />
  );
}
